module.exports = __webpack_public_path__ + "media/shared/download-failed-new@3x-87625827.png";